<script>
    import ProgressBar from './sub/ProgressBar.svelte'
    import FileIcon from './sub/FileIcon.svelte'
    import FileDownload from './sub/FileDownload.svelte'

    export let file_id

    const resolve_file = async () => {
        let req = await fetch(`/api/files/download/file_${file_id}`, {
            credentials: 'include'
        })

        let body = await req.json()

        if (body.ok) {
            return body
        } else {
            throw new Error("not found")
        }
    }
</script>

<style>
    .file_title {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;

        margin: 2em 0;
    }


</style>

<div class="page_container">
    {#await resolve_file()}
        <br>
        <ProgressBar/>
    {:then file}
        <div class="file_title">
            <FileIcon mime={file.file.mime_type} scale="xlarge"/>
            <div>
                <h1 class="title">
                    <span>{file.file.file_name}</span>
                </h1>
                <h2 class="subtitle">
                    {#if file.file.file_note}
                        {file.file.file_note}
                    {:else}
                        <i>No note.</i>
                    {/if}
                </h2>

            </div>
        </div>

        <FileDownload file={file}/>
        
    {:catch}
        <h1 class="title">File not found!</h1>
        <h2 class="subtitle">
        <a href="/">
            <span class="icon">
                <i class="fas fa-arrow-left"></i>
            </span>
            <span>Back to safety</span>
        </a>
        </h2>
    {/await}

</div>


